export default __webpack_public_path__ + "static/about-us-02-45a8ab56610c0a04e667d34da0223de1.jpg";